import { Droplet } from "lucide-react";

// Luigi Lube wordmark with a themed oil-drop icon.
export const Logo = ({ className = "", iconClass = "h-5 w-5" }) => (
  <span className={`inline-flex items-center gap-2 font-display font-semibold tracking-tight ${className}`}>
    <Droplet className={`${iconClass} shrink-0 fill-gold text-gold`} strokeWidth={0} />
    <span>LUIGI <span className="text-gradient-gold">LUBE</span></span>
  </span>
);

export default Logo;
